import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './WhiteLabel.module.css';

export const WhiteLabel = ({}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <p className={styles['white-label']}>{t('whiteLabel.brand')}</p>
    </div>
  );
};
